export enum modalType {
    settings = 'SettingModal',
    episodes = 'EpisodesModal',
    channels = 'ChannelsModal',
    related = 'RelatedModal',
}

export enum SettingName {
    AudioSubtitles = 'AudioSubtitles',
    Quality = 'Quality',
    none = 'none',
}
